import { Stack } from "@mui/material"
import { ReactElement, useContext } from "react"

import CreateEvdcDeviceProgressStepper from "./components/createEvdcDeviceProgressStepper"
import CoreEvdcDeviceDetails from "./formPages/coreEvdcDeviceDetails"
import EvdcManufacturer from "./formPages/evdcmanufacturer"
import ReviewAndSubmitEvdcDevice from "./formPages/reviewAndSubmitEvdcDevice"
import { CreateEVDCDeviceContext } from "./providers/baseProviders/createEVDCDeviceProvider"
import { Datasets } from "../../../../constants/enums"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import MultiPageForm from "../../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../../surfaces/appCard"
import LctDeviceAttachments from "../../common/components/attachments/lctDeviceAttachments"
import { EVDCDeviceFormData } from "../types/providerTypes"

/** The form for creating an EVDC device */
const CreateEVDCDeviceForm = (): ReactElement => {
    const { canEditManufacturer } = useContext(CreateEVDCDeviceContext)

    return (
        <Stack spacing={GRID_SPACING}>
            <AppCard>
                <AppCardContent>
                    <CreateEvdcDeviceProgressStepper />
                </AppCardContent>
            </AppCard>

            <MultiPageForm context={CreateEVDCDeviceContext}>
                {canEditManufacturer && (
                    <EvdcManufacturer context={CreateEVDCDeviceContext} />
                )}
                <CoreEvdcDeviceDetails context={CreateEVDCDeviceContext} />
                <LctDeviceAttachments<EVDCDeviceFormData>
                    context={CreateEVDCDeviceContext}
                    dataset={Datasets.EVDC}
                    isAmendment={false}
                />
                <ReviewAndSubmitEvdcDevice
                    context={CreateEVDCDeviceContext}
                    isAmendment={false}
                />
            </MultiPageForm>
        </Stack>
    )
}

export default CreateEVDCDeviceForm
